import {useMemo, useRef} from 'react'

export function useSyncState<TInput, TOutput>(
  input: TInput,
  process: (input: TInput) => TOutput | null,
  initialValue: TOutput,
) {
  // Employ `useMemo + useRef` instead of `useState` to avoid asynchronous state updates
  const ref = useRef(initialValue)
  return useMemo(() => {
    const value = process(input)
    if (value != null) {
      // eslint-disable-next-line react-hooks/refs
      ref.current = value
    }
    // eslint-disable-next-line react-hooks/refs
    return ref.current
  }, [input, process])
}
